import { atom } from "jotai"
import { User } from "../domain/models"

export const parkingNameAtom = atom<string | null>(null)
export const authAtom = atom<string | null>(null)
export const userAtom = atom<User | null>(null)
